// Shared football banner for discovery and enrolled competition cards.
import { getCompetitionBrandAssets, getLeagueFlag, getTypeConfig } from '../lib/competitionUtils';
import {useState} from 'react';
import {getCompetitionHeaderBrand} from '../lib/competitionHeaderBrand';
import './CompetitionCardHeader.css';

export default function CompetitionCardHeader({ comp, compact = false, leagueBranding = false, presentation = 'card' }) {
  const [failedBadge, setFailedBadge] = useState(null);
  const assets = getCompetitionBrandAssets(comp);
  const format = getTypeConfig(comp.type);
  if (leagueBranding) {
    const brand = getCompetitionHeaderBrand(comp);
    return <div className={`fc-competition-banner fc-competition-banner--league ${compact?'fc-competition-banner--compact':''} ${presentation==='context'?'fc-competition-banner--context':''}`}
      style={{'--fc-league-bg':brand.bg || undefined, '--fc-league-accent':brand.accent || undefined}}>
      <span className="fc-competition-brand-mark" aria-hidden="true">
        {brand.badgeUrl && failedBadge !== brand.badgeUrl ? <img src={brand.badgeUrl} alt="" onError={()=>setFailedBadge(brand.badgeUrl)}/> : brand.fallback}
      </span>
      <div className="fc-competition-brand-copy"><span className="fc-competition-banner__name">{brand.label}</span><span className="fc-competition-banner__format">{format.label}</span></div>
    </div>;
  }
  return <div className={`fc-competition-banner ${compact ? 'fc-competition-banner--compact' : ''}`}>
    <div className="fc-competition-banner__league">
      {assets.badgeUrl ? <img src={assets.badgeUrl} alt="" /> : <span aria-hidden="true">{getLeagueFlag(comp.league)}</span>}
      <span>{comp.league}</span>
    </div>
    <span className="fc-competition-banner__format">{format.label}</span>
  </div>;
}
